exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js??ref--6-oneOf-3-1!../node_modules/postcss-loader/src/index.js??postcss!./assets/fonts/font.css"), "");

// module
exports.push([module.id, ":root {\n  --primary: #00b4d2;\n  --secondary: #444445;\n  --WHITE: #ffffff;\n  --BLACK: #000000;\n  --WHITE-LILAC: #e7e7e7;\n  --MAGNESIUM: #b5b5b6;\n  --IRON: #d8d8d8;\n  --teal: #425471;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: 'Glacial Indifference', sans-serif;\n}\n\n.unselectable {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}", ""]);

// exports
